import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";
import Index from "./components/Index";
import Settings from "./components/Settings";
import page404 from "./components/tech/404";
import Login from "./components/tech/login";
import ListPage from "./components/list";
import VmList from "./components/lists/VmList.vue";
import ServerList from "./components/lists/ServerList";
import {BootstrapVue, IconsPlugin, ToastPlugin} from 'bootstrap-vue'
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VModal from 'vue-js-modal'
import 'vue-search-select/dist/VueSearchSelect.css'
import DcList from "@/components/lists/DcList.vue";
import InvoiceList from "@/components/lists/InvoiceList.vue";
import NetList from "@/components/lists/NetList.vue";
import LogList from "@/components/lists/LogList.vue";
import UserList from "@/components/lists/UserList.vue";
import IpList from "@/components/lists/IpList.vue";
import vSelect from 'vue-select'
import {library} from "@fortawesome/fontawesome-svg-core";
import {faRecycle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import VueTippy, {TippyComponent} from "vue-tippy";
import { EventBus } from './eventBus';

library.add(faRecycle);
import 'vue-select/dist/vue-select.css';
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";
import TaskPage from "@/components/TaskPage.vue";
import _ from "lodash";
import WikiPage from "@/components/WikiPage.vue";
import ItemLog from "@/components/ItemLog.vue";
import ItemTask from "@/components/ItemTask.vue";
import IpImportPage from "@/components/IpImportPage.vue";

Vue.use(VueTippy);
Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(VueLoading);
Vue.use(VModal);
Vue.component('v-select', vSelect)
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("tippy", TippyComponent);
const routes = [
    {
        path: "/",
        name: "index",
        component: Index,
        meta: {title: 'Home'}
    }, {
        path: "/wiki",
        name: "wiki",
        component: WikiPage,
        meta: {title: 'wiki'}
    },
    {
        path: "/vm/list",
        name: "vm",
        component: VmList,
        meta: {title: 'VMs'}
    },
    {
        path: "/server/list",
        name: "server",
        component: ServerList,
        meta: {title: 'Servers'}
    },
    {
        path: "/dc/list",
        name: "dc",
        component: DcList,
        meta: {title: 'Datacenters'}
    },
    {
        path: "/invoice/list",
        name: "invoice",
        component: InvoiceList,
        meta: {title: 'DatacentersInvoices'}
    },
    {
        path: "/net/list",
        name: "net",
        component: NetList,
        meta: {title: 'Networks'}
    },
    {
        path: "/ip/list",
        name: "ip",
        component: IpList,
        meta: {title: 'IPs'}
    },
    {
        path: "/ip/import",
        name: "ipImport",
        component: IpImportPage,
        meta: {title: 'IP import'}
    },
    {
        path: "/user/list",
        name: "user",
        component: UserList,
        meta: {title: 'Users'}
    },
    {
        path: "/settings",
        name: "settings",
        component: Settings,
        meta: {title: 'Settings'}
    },
    {
        path: "/log/list",
        name: "log",
        component: LogList,
        meta: {title: 'Logs'}
    },
    {
        path: "/log/item",
        name: "ItemLog",
        component: ItemLog,
        meta: {title: 'Logs'}
    },
    {
        path: "/task/item",
        name: "ItemTask",
        component: ItemTask,
        meta: {title: 'Logs'}
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {title: 'Login'}
    },
    {
        path: "/:page/list",
        name: "listPage",
        component: ListPage,
    },
    {
        path: "/tasks",
        name: "taskPage",
        component: TaskPage,
        meta: {title: 'Tasks'}
    },
    {
        path: "*",
        name: "404",
        component: page404,
        meta: {title: 'Not found'}
    },
];

const DEFAULT_TITLE = 'VM Manager';
const router = new VueRouter({
    routes,
    mode: "hash",
});

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('token');

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
});
router.afterEach((to) => {
    Vue.nextTick(() => {
        let new_title = `${to.meta.title} - VMM`;
        document.title = new_title || DEFAULT_TITLE;
    });
});

Vue.config.productionTip = false;
window.cacherTimeOut = 1000;
window.activityCheckTimeOut = 500;
window.cacherExKeys = [];
window.idleTime = 0;

function initUserActivity() {
    document.addEventListener("mousemove", resetTimer, false);
    document.addEventListener("keypress", resetTimer, false);
    document.addEventListener("DOMMouseScroll", resetTimer, false);
    document.addEventListener("mousewheel", resetTimer, false);
    document.addEventListener("touchmove", resetTimer, false);
    startUserActivityTimer();
}

initUserActivity();

function startUserActivityTimer() {
    window.setInterval(goInactive, window.activityCheckTimeOut);
}

function resetTimer() {
    goActive();
}

function goInactive() {
    let second = 2000;
    let minute = second * 60;
    let hour = minute * 60;
    window.idleTime = window.idleTime + window.activityCheckTimeOut;
    if (window.idleTime <= minute) { // < 1 min //1000*60
        window.cacherTimeOut = 1000; // 600 msec
    }
    if (window.idleTime > minute && window.idleTime <= minute * 5) { // < 5 min //1000*60*5
        window.cacherTimeOut = second; // 1 sec
    }
    if (window.idleTime > minute * 5 && window.idleTime < minute * 30) { // > 5 min && < 30 min
        window.cacherTimeOut = second * 3; // 3 sec
    }
    if (window.idleTime >= minute * 30) { // > 30 min
        window.cacherTimeOut = second * 10; // 10 sec
    }
    if (window.idleTime >= minute * 60) { // > 1 h
        window.cacherTimeOut = minute * 10; // 10 min
    }
    if (window.idleTime >= hour * 3) { // > 3 h
        window.cacherTimeOut = hour; // 1 h
    }
}

function goActive() {
    window.idleTime = 0;
    window.cacherTimeOut = 1000;
}


const vue = new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");

let skippedEvents = 0;
let hiddenStateStart = 0;
let hiddenStateEnd = 0;
let eventsOffStatus = false;
const eventsHubReconStep = 20;
let eventsHubReconTimer = eventsHubReconStep;
let eventsHubReconFirstTry = 0;

Vue.prototype.$eventsHub = function () {
    console.debug("eventsHub");
    let offlineStatusBar = document.getElementById("offline-status");
    if (offlineStatusBar !== null && offlineStatusBar !== undefined) {
        offlineStatusBar.setAttribute("class", "offline-status-hidden");
    }
    setTimeout(function () {
        if (Vue.prototype.$eventSource.readyState !== 2) {
            eventsHubReconFirstTry = 0;
        }
    }, 5000);

    Vue.prototype.$eventSource = new EventSource("/events/api/all/");
    Vue.prototype.$eventSource.onmessage = (event) => {
        if (document.hidden || eventsOffStatus) {
            console.debug("skip event", document.hidden);
            skippedEvents++;
            return;
        }
        eventsHubReconFirstTry = 0;
        let messageData;
        try {
            messageData = JSON.parse(event.data);
        } catch (e) {
            console.error("onmessage", e, "data:", event);
            return;
        }
        const keysArr = messageData.Key.split(':');
        if ( messageData.Key === "all:vmm:empty") {
            return;
        }
        //console.log('events onmessage', messageData.Key);
        let offlineStatusBar = document.getElementById("offline-status");
        if (offlineStatusBar !== null && offlineStatusBar !== undefined) {
            offlineStatusBar.setAttribute("class", "offline-status-hidden");
        }
        if (keysArr[0] === 'all' && keysArr[2] === 'items') {
            if (keysArr[3].startsWith("notify")) {
                vue.$bvToast.toast(messageData.Data.Msg, {
                    title: messageData.Data.Title,
                    autoHideDelay: 15000,
                    variant: 'info',
                    appendToast: true
                })
            } else if (keysArr[3].startsWith("task-add")) {
                const taskId = Object.keys(messageData.Data)[0];
                const h = vue.$createElement;
                const vNodesMsg = h(
                    'b-link',
                    {
                        attrs: { href: `/#/task/item?id=${taskId}` },
                        domProps: { innerHTML: 'Show task log' }
                    }
                );
                vue.$bvToast.toast([vNodesMsg], {
                    title: `New Task: ${messageData.Data[taskId].Name}`,
                    //noAutoHide: true,
                    autoHideDelay: 15000,
                    variant: 'info',
                    appendToast: true
                })
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('task-add', item)
                })
            } else if (keysArr[3].startsWith("task-rq")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('task-update', item)
                })
            } else if (keysArr[3].startsWith("server-rq")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('server-update', item)
                })
            } else if (keysArr[3].startsWith("server-del")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('server-delete', item)
                })
            } else if (keysArr[3].startsWith("server-add")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('server-add', item)
                })
            } else if (keysArr[3].startsWith("vm-rq")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('vm-update', item)
                })
            } else if (keysArr[3].startsWith("vm-del")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('vm-delete', item)
                })
            } else if (keysArr[3].startsWith("vm-add")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('vm-add', item)
                })
            } else if (keysArr[3].startsWith("ip-rq")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('ip-update', item)
                })
            } else if (keysArr[3].startsWith("ip-del")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('ip-delete', item)
                })
            } else if (keysArr[3].startsWith("ip-add")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('ip-add', item)
                })
            } else if (keysArr[3].startsWith("invoice-rq")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('invoice-update', item)
                })
            } else if (keysArr[3].startsWith("invoice-del")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('invoice-delete', item)
                })
            } else if (keysArr[3].startsWith("invoice-add")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('invoice-add', item)
                })
            } else if (keysArr[3].startsWith("dc-rq")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('dc-update', item)
                })
            } else if (keysArr[3].startsWith("dc-del")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('dc-delete', item)
                })
            } else if (keysArr[3].startsWith("dc-add")) {
                _.map(messageData.Data, (item) => {
                    EventBus.$emit('dc-add', item)
                })
            }
            EventBus.$emit('event', event);
        }
    }
    Vue.prototype.$eventSource.onerror = (event) => {
        console.debug('events onerror', event);
        Vue.prototype.$eventSource.close();
        let offlineStatusBar = document.getElementById("offline-status");
        if (offlineStatusBar !== null && offlineStatusBar !== undefined) {
            offlineStatusBar.setAttribute("class", "offline-status");
        }
        Vue.prototype.$eventsReconnect();
    }
}
Vue.prototype.$eventsHub();

Vue.prototype.$eventsReconnect = function () {
    let restartTimer = document.getElementById("reconnect-timer");
    if (restartTimer === null || restartTimer === undefined) {
        return;
    }
    if (Vue.prototype.$eventSource.readyState !== 2) {
        return;
    }
    if (eventsHubReconFirstTry > 5) {
        restartTimer.textContent = " auto reconnect stopped";
        return;
    }

    if (eventsHubReconFirstTry === 0) {
        eventsHubReconFirstTry++;
        setTimeout(Vue.prototype.$eventsHub, 800);
        return;
    }
    if (eventsHubReconTimer > 0) {
        restartTimer.textContent = " auto reconnect after: " +  eventsHubReconTimer + " seconds";
        eventsHubReconTimer--;
        setTimeout(Vue.prototype.$eventsReconnect, 1000);
    } else {
        restartTimer.textContent = " auto reconnect start...";
        Vue.prototype.$eventsHub();
        eventsHubReconTimer = eventsHubReconStep;
    }
    eventsHubReconFirstTry++;
}

function handleShortcut(event) {
    if (event.keyCode === 27 || event.code === "Escape") {
        event.preventDefault();
        EventBus.$emit('EscapeKeyDown', true);
    }
}

function visibilitychange(event) {
    console.debug('visibilitychange main hidden', document.hidden, event);
    if (!document.hidden) {
        hiddenStateEnd = Math.round(Date.now() / 1000)
        EventBus.$emit('visibilitychange', {events:skippedEvents, tasks:skippedEvents, seconds: hiddenStateStart - hiddenStateEnd});
    } else {
        hiddenStateEnd = 1;
        hiddenStateStart = Math.round(Date.now() / 1000)
    }
}

function eventsHandleChange(status) {
    eventsOffStatus = status;
    localStorage.setItem('eventsOffStatus', status);
}

document.addEventListener("keydown", handleShortcut);
document.addEventListener("visibilitychange", visibilitychange);
EventBus.$on("events-off-status", eventsHandleChange);

